import React, { Suspense, lazy } from 'react';
import { Routes as RouterRoutes, Route, useLocation, useNavigate } from 'react-router-dom';
import List10Q10K      from './features/report/list_10q10k';
import Latest10Q10K    from './features/report/latest_10q10k';
import App_transcript  from './features/report/App_transcript';
import ListNews        from './features/report/list_News';
import Income          from './features/financial/Income';
import Balance         from './features/financial/Balance';
import Cashflow        from './features/financial/Cashflow';
import TopCompanies    from './features/screening/topcompanies';
import TopMomentum     from './features/screening/top_momentum';
import Home            from './features/home/Home';
import StockComparison from './features/screening/StockComparison';
import CrossWindowTest from './features/user/auth/CrossWindowTest';

import Profile         from './features/user/ProfilePage';
import Watchlist       from './features/user/WatchlistPage';
import NoticePage      from './features/user/NoticePage';
import RegisterDialog  from './features/user/auth/RegisterDialog';
import VerifyResultPage from './features/user/VerifyResultPage';


// 导入新的FinanceGPT组件
import FinanceGPT from './features/company/finance-gpt';

// 如果导入了ActivityTracker
import activityTracker from './features/user/ActivityTracker';

import AboutMe from './features/aboutme';
import Prices from './features/billing/Prices';
import MainInfo from './features/company/maininfo';

// 懒加载大型组件
const Candlestick = lazy(() => import('./features/technical/Candlestick'));
const StockScreener = lazy(() => import('./features/screener/StockScreener'));
const KeyMetric = lazy(() => import('./features/financial/KeyMetric'));
const Estimate = lazy(() => import('./features/financial/estimate'));
const BusinessProduct = lazy(() => import('./features/report/business-product'));

function Routes({ transcriptData, setTranscriptData }) {
  const location = useLocation();
  const navigate = useNavigate();

  // 从 URL 获取 symbol 参数
  const getSymbolFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('symbol') || '';
  };

  return (
    <Suspense fallback={<div>加载中...</div>}>
      <RouterRoutes>
        <Route path="/" element={<Home />} />
        <Route path="/top-companies" element={<TopCompanies />} />
        <Route path="/top-momentum" element={<TopMomentum />} />
        <Route
          path="/list-10q10k"
          element={<List10Q10K initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/latest-10q10k"
          element={<Latest10Q10K initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/maininfo"
          element={<MainInfo initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/business-product"
          element={<BusinessProduct initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/list-news"
          element={<ListNews initialSymbol={getSymbolFromUrl()} />} 
        />
        <Route
          path="/transcript"
          element={
            <App_transcript
              initialSymbol={getSymbolFromUrl()}
              transcriptData={transcriptData}
              setTranscriptData={setTranscriptData}
            />
          } 
        />
        <Route path="/income" element={<Income initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/balance" element={<Balance initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/cashflow" element={<Cashflow initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/keymetric" element={<KeyMetric initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/estimate" element={<Estimate initialSymbol={getSymbolFromUrl()} />} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/watchlist" element={<Watchlist/>} />
        <Route path="/pages/finance-gpt" element={<FinanceGPT />} />
        <Route path="/pages/stock-comparison" element={<StockComparison />} />
        <Route path="/pages/stock-screener" element={<StockScreener />} />
        <Route path="/technical/:symbol" element={<Candlestick />} />
        <Route path="/notice" element={<NoticePage />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/prices" element={<Prices />} />
        <Route path="/register" element={<RegisterDialog open={true} onClose={() => navigate('/')} />} />
        <Route path="/verify-result" element={<VerifyResultPage />} />

        <Route path="/cross-window-test" element={<CrossWindowTest />} />
      </RouterRoutes>
    </Suspense>
  );
}

export default Routes;